
import { defineComponent } from "vue";
import Index from "@/components/change_logs/Index.vue";

export default defineComponent({
  components: {
    Index,
  },
});
